import BreakpointsEnum from "../enums/breakpointsEnum";
import {nextArrow, prevArrow} from "../components/slick-arrow";

let $thumbnailSlider = $('.product-slider .thumbnail');

function initThumbnailSlider() {
    $thumbnailSlider.slick({
        asNavFor: '.product-slider .main',
        slidesToShow: 5,
        arrows: true,
        dots: false,
        infinite: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        speed: 300,
        rows: 0,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 5,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    vertical: true,
                    verticalSwiping: true,
                }
            },
            {
                breakpoint: 768,
                settings: 'unslick'
            }
        ]
    });
}

if (window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
    initThumbnailSlider();
}

$(window).on('resize', function () {
    if ((!$thumbnailSlider.hasClass('slick-initialized')) && window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
        initThumbnailSlider();
    }
});